// extracted by mini-css-extract-plugin
export default {"root":"MSALBar_root__48dJs"};